import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'

import { useGuideSteps } from './use-guide-steps'


export const useCurrentUserGuideSection = () => {
  const data = useGuideSteps()
  const {
    data: {
      activation_data: {
        current_user_guide_section: userGuideSectionIdentifier
      } = {}
    }
  } = useGetUserQuery()
  const currentViewSection = data?.collection?.find(
    (section) => section.identifier === userGuideSectionIdentifier
  )
  const [update] = useUpdateUserActivationDataMutation()

  return [
    currentViewSection,
    (newViewIdentifier) => update({ current_user_guide_section: newViewIdentifier ?? '' })
  ]
}
